import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ResultGrid } from '../grid/ResultGrid';
import { Column } from '../grid/Column';
import { RawHtml } from '../form/RawHtml';
import { refColumns, refSort, minColumns } from '../../redux/InfoReduxConstant';

export const ReferencesTable = ({
  references, handleToggleColumns, sort, visibleColumns,
}) => (
  <ResultGrid
    data={references}
    sort={sort}
    handleColumnsToggle={handleToggleColumns}
    columnChooser
    visibleColumns={visibleColumns}
    defaultColumns={refColumns}
    defaultSort={refSort}
    minColumns={minColumns}
  >
    <Column id="id" width={120} sortable>Id</Column>
    <Column id="author" width={300} sortable>Author</Column>
    <Column id="year" width={150} sortable>Year</Column>
    <Column id="citation" width={300} sortable cell={({ value }) => (<RawHtml>{value}</RawHtml>)}>Citation</Column>
  </ResultGrid>
);


ReferencesTable.propTypes = {
  references: ImmutablePropTypes.list.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  handleToggleColumns: PropTypes.func.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
};
